module.exports = __webpack_public_path__ + "static/media/12UNCTAD9.1805072d.jpg";